import { setTerm } from './helpers';

export const setPromo = setTerm('promo');
